const tagsPadrao = ['alfabetizacao360'];

export default tagsPadrao;
